import { createFileRoute, redirect } from '@tanstack/react-router';

/** /settings/data-connector/outbound は既定で出力パイプライン一覧へ。 */
export const Route = createFileRoute('/_staff/settings/data-connector/outbound/')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings/data-connector/outbound/data-pipeline'
    });
  }
});